import { RouteObject } from "react-router";

export const DocumentsRoutes: RouteObject[] = [
  {
    path: "",
    async loader(args) {
      const { documentsTabLoader } = await import("src/router/loaders/jobs/Documents");
      return documentsTabLoader(args);
    },
    async lazy() {
      const { DocumentsTab } = await import("jobs/Job/DocumentsTab");
      return { element: <DocumentsTab /> };
    },
  },
];
